import React, { Component } from 'react'

import slackLogo from '../../assets/icons/Slack-Small.png'
import teamsLogo from '../../assets/icons/Teams-Small.png'
import moment from 'moment'
import { toastContainer } from '../../utils/toast'
import { Popover, PopoverBody } from 'reactstrap'
import { Popover as PopoverTiny } from 'react-tiny-popover'
import 'rc-checkbox/assets/index.css'
import {
  BiDotsHorizontalRounded,
  BiShare,
  BiMailSend,
  BiCopy,
  BiLogoSlack,
  BiLogoMicrosoftTeams,
  BiLogoGoogle,
} from 'react-icons/bi'
import {
  baseUrl,
  DANI_SLACK_MEMEBER_MESSAGE,
  TRIVVY_SLACK_MEMEBER_MESSAGE,
  uploadPreview,
} from '../../utils/constants'

import axios from '../../axios'
import * as url from '../../utils/url'
import SlackSharePopup from '../SlackAndTeamsPopups/SlackSharePopup'
import TeamsSharePopup from '../SlackAndTeamsPopups/TeamsSharePopup'
import TurndownService from 'turndown'
import { gfm } from 'turndown-plugin-gfm'
import If from '../Shared/If'
import { capitalizeFirstLetterOtherSmall } from '../../utils/stringUtils'
import { data } from 'jquery'

export default class ShareEntity extends Component {
  constructor(props) {
    super(props)
    this.state = {
      shareOpen: false,
      showSlackShare: false,
      showTeamsShare: false,
    }
  }

  showSelectSlackchannels = () => {
    this.setState({ showSlackShare: true, shareOpen: false })
  }
  showSelectTeamschannels = () => {
    this.setState({ showTeamsShare: true, shareOpen: false })
  }

  handleDescAttachments = (text, data) => {
    const { item } = this.props
    if (
      item.image ||
      (item.ogp && item.ogp.ogImage) ||
      (item.attachments && item.attachments.length)
    ) {
      text += '<br><b>Attachments:</b><br>'
      if (item.image) {
        if (data.type === 'SLACK') {
          text += `Type : Image <br> ${item.image} <br>`
        } else {
          text += `<div><a href=${item.image}><img src=${item.image}></a></div>`
        }
      }
      if (item.ogp && item.ogp.ogImage) {
        if (data.type === 'SLACK') {
          text += `Type : Image <br> ${item.ogp.ogImage.url} <br>`
        } else {
          text += `<div><a href=${item.ogp.ogImage.url}><img src=${item.ogp.ogImage.url}></a></div>`
        }
      }
      if (item.attachments && item.attachments.length) {
        for (const itm of item.attachments) {
          if (itm.type && itm.type.mime && itm.url) {
            if (
              (itm.type && itm.type.mime.indexOf('image') > -1) ||
              itm.type.mime.indexOf('video') > -1
            ) {
              const isVideo = itm.type.mime.indexOf('video') > -1
              if (data.type === 'SLACK') {
                text += `Type : ${itm.type.mime} <br> ${itm.url} <br>`
              } else {
                if (isVideo) {
                  text += `<b>Type : ${itm.type.mime}</b>  <br>  <a target="_blank" href=${itm.url}> ${itm.url} </a>  <br>`
                } else {
                  text += `<div><a href=${itm.url}> <br><img src=${itm.url}></a> </div>`
                }
              }
            } else {
              if (data.type === 'SLACK') {
                text += `Type : ${itm.type.mime} <br>   ${itm.url}   <br>`
              } else {
                const upload = uploadPreview(itm)
                if (upload.isMsIcon) {
                  text += `<b> Type : ${itm.type.mime} </b>  <br>  <a target="_blank" href=${itm.url}> ${itm.url} </a>  <br>`
                }
              }
            }
          }
        }
      }
    }

    return text
  }

  createEmailTxt = () => {
    if (this.props.entityType === 'STORY') {
      let { item } = this.props
      let text = item.description
      if (text.indexOf('<table') > -1) {
        text = new TurndownService().use(gfm).turndown(text)
        const mentionUrlRegex = /\(\/home\/[a-f\d]{24}\/profile\/[a-f\d]{24}\)/g
        text = text.replace(mentionUrlRegex, '')
        const pattern = /\((https?:\/\/[^\s)]+)\)/g
        text = text.replace(pattern, '')
      }

      text = text.replace(/<[^>]+>/g, '').replaceAll('**', '')

      let attachText = this.handleDescAttachments('', { type: 'SLACK' })

      if (data.type === 'SLACK') {
        attachText =
          attachText + `<br> Story Link : ${baseUrl()}home/stories/${item._id} `
      } else {
        attachText =
          attachText +
          `<br> Story Link : <a href=${baseUrl()}home/stories/${
            item._id
          }> ${baseUrl()}home/stories/${item._id} </a> `
      }

      attachText = attachText
        .replaceAll('<br>', '\n')
        .replaceAll('<b>', '')
        .replaceAll('</b>', '')
        .replaceAll('<strong>', '')
        .replaceAll('</strong>', '')
      return text + attachText
    } else if (this.props.entityType === 'ACTION') {
      let { item } = this.props

      let text = this.getTextForAction(item)

      text = new TurndownService().use(gfm).turndown(text)

      return text
    } else if (this.props.entityType === 'RESOURCES') {
      let { item } = this.props

      let text = this.getTextFormatForResources(item, 'SLACK')

      text = new TurndownService().use(gfm).turndown(text)

      return text
    } else if (this.props.entityType === 'TRIVVY') {
      let { item } = this.props

      let text = this.getTextFormatForTrivia(item, 'SLACK')

      text = new TurndownService().use(gfm).turndown(text)

      return text
    }
  }

  getTextForAction = (item) => {
    let finalString = `<div>
     <div>
        <ul>
        {{middle_string}}
        </ul>
     </div>
     </div>`

    let middle_string = ''

    if (item.title) {
      middle_string += `<li> Title:  ${item.title}</li>`
    }
    if (item.assigneeName) {
      middle_string += `<li> Assignee:  ${item.assigneeName}</li>`
    }

    if (item.dueDate) {
      middle_string += `<li> Due Date:  ${item.dueDate}</li>`
    }

    if (item.progress) {
      middle_string += `<li> Progress:  ${item.progress}</li>`
    }

    if (item.status) {
      middle_string += `<li> Status:  ${item.status}</li>`
    }

    if (item.objectiveName) {
      middle_string += `<li> Objective Name:  ${item.objectiveName}</li>`
    }

    if (item.priority) {
      middle_string += `<li> Priority:  ${item.priority}</li>`
    }

    if (item.privacy) {
      middle_string += `<li> Privacy:  ${item.privacy}</li>`
    }

    if (item.createdByName) {
      middle_string += `<li> Created By:  ${item.createdByName}</li>`
    }

    if (item.createdOn) {
      middle_string += `<li> Created On:  ${item.createdOn}</li>`
    }

    if (item.description && item.description.length) {
      middle_string += `<li> Description :${item.description.slice(3)} </li>`
    }

    if (item._id) {
      middle_string += `<li> Task Url  :${baseUrl()}home/planning/${
        item._id
      } </li>`
    }

    finalString = finalString.replace('{{middle_string}}', middle_string)

    return finalString
  }

  getDiversityFocusValue = (toolDetails, diversityFocus) => {
    if (toolDetails.diversityFocus && toolDetails.diversityFocus.length > 0) {
      toolDetails.diversityFocus.forEach((selectedFocus) => {
        if (diversityFocus === '' && selectedFocus.focus) {
          diversityFocus =
            selectedFocus.focus !== 'Other'
              ? selectedFocus.focus
              : toolDetails.diversityFocusTags.replace(/,/g, ', ')
        } else if (selectedFocus.focus) {
          diversityFocus +=
            ', ' +
            (selectedFocus.focus !== 'Other'
              ? selectedFocus.focus
              : toolDetails.diversityFocusTags.replace(/,/g, ', '))
        }
      })
    } else if (
      toolDetails.diversityFocusTags &&
      toolDetails.diversityFocusTags !== ''
    ) {
      diversityFocus = toolDetails.diversityFocusTags.replace(/,/g, ', ')
    }
    return diversityFocus
  }

  getAimedAtFocusValue = (toolDetails, aimedAt) => {
    if (toolDetails.relevantFor && toolDetails.relevantFor.length > 0) {
      toolDetails.relevantFor.forEach((selectedFocus) => {
        if (aimedAt === '' && selectedFocus.focus) {
          aimedAt =
            selectedFocus.focus !== 'Other'
              ? selectedFocus.focus
              : toolDetails.relevantForTags.replace(/,/g, ', ')
        } else if (selectedFocus.focus) {
          aimedAt +=
            ', ' +
            (selectedFocus.focus !== 'Other'
              ? selectedFocus.focus
              : toolDetails.relevantForTags.replace(/,/g, ', '))
        }
      })
    } else if (
      toolDetails.relevantForTags &&
      toolDetails.relevantForTags !== ''
    ) {
      aimedAt = toolDetails.relevantForTags.replace(/,/g, ', ')
    }
    return aimedAt
  }

  getTextFormatForResources = (tool, dataType) => {
    const item = { ...tool }

    let diversityFocus = ''
    let aimedAt = ''
    diversityFocus = this.getDiversityFocusValue(tool, diversityFocus)

    aimedAt = this.getAimedAtFocusValue(tool, aimedAt)

    const attachmentsArr =
      item.attachments && item.attachments.length ? [...item.attachments] : []

    if (item.image) {
      attachmentsArr.push({ type: { mime: 'Image' }, url: item.image })
    }
    if (item.attachment) {
      attachmentsArr.push({ type: { mime: 'File' }, url: item.attachment })
    }

    let finalString = `
     <div>
        <ul>
        {{middle_string}}
        </ul>
     </div>
     `

    let middle_string = ''

    if (item.name) {
      const isEvent = tool.category === 'Conferences & Events'
      middle_string += `<li> Name:  ${item.name} ${
        isEvent
          ? `(${moment(tool.startDate).format('MMM D, YYYY')} -  ${moment(
              tool.endDate
            ).format('MMM D, YYYY')})`
          : ''
      } </li>`
    }
    if (item.category) {
      middle_string += `<li> Category:  ${item.category} </li>`
    }
    if (item.subCategory) {
      middle_string += `<li>Sub Category:  ${item.subCategory.subCategoryKey ||
        ''} </li>`
    }
    if (item.createdBy) {
      middle_string += `<li> Created By:${item.createdBy.firstName || ''}${item
        .createdBy.lastName || ''} </li>`
    }
    if (item.diversityFocus && item.diversityFocus.length) {
      middle_string += `<li> Diversity:${diversityFocus} </li>`
    }
    if (item.relevantFor && item.relevantFor.length) {
      middle_string += `<li> Aimed at :  ${aimedAt} </li>`
    }

    if (item.bannerImg && item.bannerImg.url) {
      if (dataType === 'SLACK') {
        middle_string += `<li> Banner Image :${item.bannerImg.url} </li>`
      } else {
        middle_string += `<li> Banner Image : <a href="${item.bannerImg.url}" target="_blank">${item.bannerImg.url}</a> </li>`
      }
    }

    if (item.description && item.description.length) {
      middle_string += `<li> Description :${item.description.slice(3)} </li>`
    }

    if (attachmentsArr.length) {
      if (dataType === 'SLACK') {
        middle_string += `<li> <b> Attachments </b> : <ul> ${attachmentsArr
          .map((x) => {
            if (x.type && x.type.mime && x.url) {
              return `<li>
              Type:${x.type.mime}  ${x.url}
              </li>`
            } else {
              return ''
            }
          })
          .join('')}  </ul></li>`
      } else {
        middle_string += `<li> <b> Attachments </b> : <ul> ${attachmentsArr
          .map((x) => {
            if (x.type && x.type.mime && x.url) {
              const upload = uploadPreview(x)
              if (upload.isMsIcon) {
                return `<li><b> Type : ${x.type.mime} </b>   <a target="_blank" href=${x.url}> ${x.url} </a>  <br></li>`
              } else {
                return `<li><a href=${x.url}> <br><img src=${x.url}></a> </li>`
              }
            } else {
              return ''
            }
          })
          .join('')}  </ul></li>`
      }
    }
    if (item._id && item._id) {
      if (dataType === 'SLACK') {
        middle_string += `<li> Resource Url  :${baseUrl()}home/toolkit/all/tool/${
          item._id
        } </li>`
      } else {
        middle_string += `<li> Resource Url  :<a href=${baseUrl()}home/toolkit/all/tool/${
          item._id
        }> ${baseUrl()}home/toolkit/all/tool/${item._id} </a> </li>`
      }
    }

    finalString = finalString.replace('{{middle_string}}', middle_string)

    return finalString
  }

  getTextFormatForTrivia = (tool, dataType) => {
    const item = { ...tool }
    let finalString = `
     <div>
        <ul>
        {{middle_string}}
        </ul>
     </div>
     `

    let middle_string = ''

    if (item.triviaName) {
      middle_string += `<li> Name:  ${item.triviaName} </li>`
    }
    if (item.createdBy) {
      middle_string += `<li> Created by:  ${item.createdBy} </li>`
    }
    if (item.totalQuestions) {
      middle_string += `<li>Total Questions:  ${item.totalQuestions} </li>`
    }

    if (item.totalCorrect) {
      middle_string += `<li>Total Correct:  ${item.totalCorrect} </li>`
    }

    if (item.totalWrong) {
      middle_string += `<li>Total Wrong:  ${item.totalWrong} </li>`
    }
    if (item.triviaLink) {
      middle_string += `<li>Trivvy Link:  ${item.triviaLink} </li>`
    }
    if (item.timeTaken >= 0) {
      middle_string += `<li>Time Taken:  ${item.timeTaken} secs </li>`
    }
    if (item.correctPercent) {
      middle_string += `<li>Correct Percent:  ${item.correctPercent} % </li>`
    }

    finalString = finalString.replace('{{middle_string}}', middle_string)

    return finalString
  }

  handleSocialShare = async (data) => {
    return new Promise((resolve, reject) => {
      const { item, entityType } = this.props
      let text = ''
      let attachText = ''

      if (entityType === 'STORY') {
        text = item.description.replace(
          '<div><b>Answer:</b>',
          '\n<div><b>Answer:</b>'
        )
        attachText = this.handleDescAttachments('', data)
        attachText =
          attachText + `<br> Story Link : ${baseUrl()}home/stories/${item._id} `
        if (data.type === 'SLACK' && text.indexOf('<table') > -1) {
          text = new TurndownService().use(gfm).turndown(text)
          const mentionUrlRegex = /\(\/home\/[a-f\d]{24}\/profile\/[a-f\d]{24}\)/g
          text = text.replace(mentionUrlRegex, '')
          const pattern = /\((https?:\/\/[^\s)]+)\)/g
          text = text.replace(pattern, '')
        }
        if (data.type === 'SLACK') {
          attachText = attachText
            .replaceAll('<br>', '\n')
            .replaceAll('<b>', '')
            .replaceAll('<p>', '\n<p>')
            .replaceAll('</b>', '')
            .replaceAll('<strong>', '')
            .replaceAll('</strong>', '')
        }
      } else if (entityType === 'ACTION') {
        text = this.getTextForAction(item)

        if (data.type === 'SLACK') {
          text = text.replaceAll('<b>', '').replaceAll('</b>', '')
        }
      } else if (entityType === 'RESOURCES') {
        text = this.getTextFormatForResources(item, data.type)
        if (data.type === 'SLACK') {
          text = text.replaceAll('<b>', '').replaceAll('</b>', '')
        }
      } else if (entityType === 'TRIVVY') {
        text = this.getTextFormatForTrivia(item, data.type)
        if (data.type === 'SLACK') {
          text = text.replaceAll('<b>', '').replaceAll('</b>', '')
        }
      }

      let payload = {
        storyText: text,
        attachmentsText: attachText,
        user: {
          username: data.isAnonymous
            ? 'Anonymous'
            : `${this.props.user.profile.firstName} ${this.props.user.profile.lastName}`,
          text: '',
        },
        entityType: entityType,
        channelId: data.channelId,
        channelName: data.channelName,
        type: data.type,
        workSpaceId: data.workSpaceId,
        teamId: data.teamId,
        tenantId: data.tenantId,
      }

      axios
        .post(url.shareStoryPost, payload)
        .then(({ data }) => {
          // console.log("data shared----", data);
          toastContainer('Shared successfully', 'success')
          console.log('resolving', payload.channelId)
          const method = payload.type === 'SLACK' ? 2 : 3
          this.handleShareStore(method, payload.channelName)
          resolve(payload.channelId)
        })
        .catch((error) => {
          let message = 'Error occured while sending message'
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors &&
            error.response.data.errors.message === 'channel_not_found'
          ) {
            message =
              entityType === 'TRIVVY'
                ? TRIVVY_SLACK_MEMEBER_MESSAGE
                : DANI_SLACK_MEMEBER_MESSAGE
          }
          toastContainer(message, 'error')
          reject(message)
        })
    })
  }

  handleShareStore = (method, type) => {
    let onModel = 'Story'

    const { item, entityType } = this.props

    if (entityType === 'ACTION') {
      onModel = 'Task'
    }
    if (entityType === 'RESOURCES') {
      onModel = 'OfficeToolkit'
    }
    let payload = {
      shareMethod: method,
      shareType: type,
      itemId: item._id,
      itemModel: onModel,
    }

    axios
      .post(url.storeShareLogs, payload)
      .then((data) => {
        console.log('stored_shared', data)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  render() {
    let { shareOpen, showSlackShare, showTeamsShare } = this.state
    const { item, display, isTiny, pooverUIMobileBorderClass } = this.props

    const teamsEnabled =
      this.props.user.profile.organizationId &&
      this.props.user.profile.organizationId.allowedTeamsTenants
        ? this.props.user.profile.organizationId.allowedTeamsTenants.length > 0
        : false
    const slackEnabled =
      this.props.user.profile.organizationId &&
      this.props.user.profile.organizationId.allowedSlackWorkspaces
        ? this.props.user.profile.organizationId.allowedSlackWorkspaces.length >
          0
        : false

    const popoverUI = (
      <PopoverBody className={`cursor-pointer ${pooverUIMobileBorderClass}`}>
        {!this.props.noSlackTeams && (
          <div
            className={
              slackEnabled
                ? 'dropdown-item'
                : 'dropdown-item slack_menuitem_disable'
            }
            onClick={() =>
              slackEnabled ? this.showSelectSlackchannels() : null
            }>
            <BiLogoSlack size={23} className="mr-2 ml-1" />
            {slackEnabled ? 'Share To Slack' : 'Slack not enabled'}
          </div>
        )}

        {/* {!this.props.noSlackTeams && (
          <div
            className={
              teamsEnabled
                ? "dropdown-item"
                : "dropdown-item teams_menuitem_disable"
            }
            onClick={() =>
              teamsEnabled ? this.showSelectTeamschannels() : null
            }
          >
            <BiLogoMicrosoftTeams size={23} className="mr-2 ml-1" />
            {teamsEnabled ? "Share To Teams" : "Teams not enabled"}
          </div>
        )} */}

        <div
          className="dropdown-item"
          onClick={(e) => {
            e.stopPropagation()
            window.open(
              `mailto:someone@yoursite.com?subject=${`${capitalizeFirstLetterOtherSmall(
                this.props.entityType
              )} Share`}&body=${encodeURIComponent(this.createEmailTxt())}`
            )
          }}>
          <BiMailSend size={23} className="mr-2" /> Share To Outlook
        </div>
        <div
          className="dropdown-item"
          onClick={(e) => {
            e.stopPropagation()
            window.open(
              `https://mail.google.com/mail/u/0/?fs=1&to=&su=${`${capitalizeFirstLetterOtherSmall(
                this.props.entityType
              )} Share`}&body=${encodeURIComponent(
                this.createEmailTxt()
              )}&tf=cm`
            )
          }}>
          {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                fill="currentColor"
                viewBox="0 0 16 22"
                className="mr-2"
              >
                <path d="M15.545 6.558a9.42 9.42 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.689 7.689 0 0 1 5.352 2.082l-2.284 2.284A4.347 4.347 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.792 4.792 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.702 3.702 0 0 0 1.599-2.431H8v-3.08h7.545z" />
              </svg> */}
          <BiLogoGoogle size={23} className="mr-2 ml-1" />
          Share Via Gmail
        </div>

        <div
          className="dropdown-item"
          onClick={(e) => {
            e.stopPropagation()
            navigator.clipboard.writeText(this.createEmailTxt())
            toastContainer('Copied successfully', 'success')
          }}>
          <BiCopy className="mr-2 ml-1" size={23} />
          Copy
        </div>
      </PopoverBody>
    )

    return (
      <div
        className={`${
          this.props.noMainClass ? 'ml-1 d-inline-blk' : 'comment-action-item'
        } ${this.props.col ? 'mr-0' : 'mr-2'} ${this.props.customClass}`}
        style={{ marginLeft: this.props.col ? 'auto' : 'none' }}>
        {!isTiny ? (
          <If condition={true}>
            <div
              id={`story_share_popover_${item._id}`}
              onClick={() =>
                this.setState({ shareOpen: !this.state.shareOpen })
              }>
              {this.props.comp ? (
                this.props.comp
              ) : (
                <span>
                  {' '}
                  <BiShare size="22px" /> Share
                </span>
              )}
            </div>
            <Popover
              isOpen={shareOpen}
              toggle={() => this.setState({ shareOpen: !this.state.shareOpen })}
              target={`story_share_popover_${item._id}`}
              placement="top"
              className="dani-share-popover"
              hideArrow>
              {popoverUI}
            </Popover>
          </If>
        ) : (
          <PopoverTiny
            positions={
              this.props.customTinyPositions
                ? this.props.customTinyPositions
                : ['right', 'bottom']
            }
            containerStyle={{
              marginLeft:
                this.props.customTinyPositions &&
                this.props.customTinyPositions.includes('left')
                  ? '0px'
                  : '10px',
              zIndex: '99999',
              marginTop: '20px',
              background: 'white',
            }}
            isOpen={shareOpen}
            onClickOutside={() =>
              this.setState({ shareOpen: !this.state.shareOpen })
            }
            className={'parent-nested-subaction-popover cursor-pointer'}
            content={() => popoverUI}>
            <div
              id={`story_share_popover_${item._id}`}
              onClick={() =>
                this.setState({ shareOpen: !this.state.shareOpen })
              }>
              {this.props.comp ? (
                this.props.comp
              ) : (
                <span>
                  {' '}
                  <BiShare size="22px" /> Share
                </span>
              )}
            </div>
          </PopoverTiny>
        )}

        {showSlackShare && (
          <SlackSharePopup
            handleSocialShare={this.handleSocialShare}
            slackShared={[]}
            answer={''}
            orgId={this.props.user.profile.organizationId._id}
            userId={this.props.user.profile._id}
            setShowSlackPopup={(val) => this.setState({ showSlackShare: val })}
            organization={this.props.user.profile.organizationId}
          />
        )}
        {showTeamsShare && (
          <TeamsSharePopup
            handleSocialShare={this.handleSocialShare}
            teamsShared={[]}
            answer={''}
            orgId={this.props.user.profile.organizationId._id}
            userId={this.props.user.profile._id}
            setShowTeamsPopup={(val) => this.setState({ showTeamsShare: val })}
            organization={this.props.user.profile.organizationId}
          />
        )}
      </div>
    )
  }
}
